module.exports = __webpack_public_path__ + "static/media/16UNODC38.5a5207a4.jpg";